import MuiPaper from '@mui/material/Paper';
import type { ComponentProps } from 'react';

export const Paper = (props: ComponentProps<typeof MuiPaper>) => {
  return <MuiPaper {...props} />;
};
